import { CajaList } from './CajaList';
import { FaCashRegister } from 'react-icons/fa';

export default {
  list: CajaList,
  icon: FaCashRegister
};